var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"home-banner-image"},[_c('div',{staticClass:"home-banner-image__container"},[_c('hot-banner-image',_vm._b({},'hot-banner-image',_vm.data,false))],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }